// extracted by mini-css-extract-plugin
export default {"header":"reports-details_header__y2nR5","btnText":"reports-details_btnText__8HGE7"};